import { Modal } from "react-bootstrap";
import { useTheme } from "../../../hooks/ThemeProvider";

export default function ActionSuccessModal({
  show,
  handleClose,
  title = "Success",
  heading = "Transaction Successful!",
  message,
  noteTitle,
  noteDesc,
  amount,
  tokenSymbol,
  txHash,
  viewTx,
}) {
  // Shorten hash for UI
  const shortenHash = (hash) =>
    hash ? `${hash.slice(0, 10)}...${hash.slice(-4)}` : "";
  const { theme } = useTheme();
  return (
    <Modal className="stakingmodal" show={show} onHide={() => { handleClose(true) }} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <p>{title}</p>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="succes_modal">
          <div className="top_success">
            <img src="\assets\tick.svg" alt="success" />
            <h3>{heading}</h3>
            {message ? (
              <p>{message}</p>
            ) : (
              <p>
                You’ve successfully processed{" "}
                <span>
                  {amount} {tokenSymbol}
                </span>
              </p>
            )}
          </div>

          {viewTx && (
            <div className="hash_div">
              <div>
                <p>Transaction Hash</p>
                <span>{shortenHash(txHash)}</span>
              </div>
              {viewTx && (
                <a href={viewTx} target="_blank" rel="noopener noreferrer">
                  <button>
                    {
                      theme === 'dark' ? <img src="\assets\whitetab.svg" alt="view" />
                        : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                          <path d="M12.25 8.08333V11.5833C12.25 11.8928 12.1271 12.1895 11.9083 12.4083C11.6895 12.6271 11.3928 12.75 11.0833 12.75H2.91667C2.60725 12.75 2.3105 12.6271 2.09171 12.4083C1.87292 12.1895 1.75 11.8928 1.75 11.5833V3.41667C1.75 3.10725 1.87292 2.8105 2.09171 2.59171C2.3105 2.37292 2.60725 2.25 2.91667 2.25H6.41667" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M12.25 2.25L7 7.5" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M8.75 2.25H12.25V5.75" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    }

                    View
                  </button>
                </a>
              )}
            </div>

          )}
          {noteTitle &&<div className="outer_layerofyellowdiv">
   <div className="yellowsection">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M11 17H13V11H11V17ZM12 9C12.2833 9 12.521 8.904 12.713 8.712C12.905 8.52 13.0007 8.28267 13 8C12.9993 7.71733 12.9033 7.48 12.712 7.288C12.5207 7.096 12.2833 7 12 7C11.7167 7 11.4793 7.096 11.288 7.288C11.0967 7.48 11.0007 7.71733 11 8C10.9993 8.28267 11.0953 8.52033 11.288 8.713C11.4807 8.90567 11.718 9.00133 12 9ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88334 20.6867 5.825 19.9743 4.925 19.075C4.025 18.1757 3.31267 17.1173 2.788 15.9C2.26333 14.6827 2.00067 13.3827 2 12C1.99933 10.6173 2.262 9.31733 2.788 8.1C3.314 6.88267 4.02633 5.82433 4.925 4.925C5.82367 4.02567 6.882 3.31333 8.1 2.788C9.318 2.26267 10.618 2 12 2C13.382 2 14.682 2.26267 15.9 2.788C17.118 3.31333 18.1763 4.02567 19.075 4.925C19.9737 5.82433 20.6863 6.88267 21.213 8.1C21.7397 9.31733 22.002 10.6173 22 12C21.998 13.3827 21.7353 14.6827 21.212 15.9C20.6887 17.1173 19.9763 18.1757 19.075 19.075C18.1737 19.9743 17.1153 20.687 15.9 21.213C14.6847 21.739 13.3847 22.0013 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#E88F35" />
              </svg>
              <div>
                <h4>{noteTitle}</h4>
                <p>{noteDesc}</p>
              </div>

            </div>
          </div>}


          <div className="buton_modal_div">
            <button onClick={() => { handleClose(true) }}>Close</button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
